import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#DB2547",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 7.922v4.66"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#DB2547",
      d: "M12 16.082a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#DB2547",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 21.25a9.25 9.25 0 1 0 0-18.5 9.25 9.25 0 0 0 0 18.5"
    }, null, -1)
  ])))
}
export default { render: render }